// extracted by mini-css-extract-plugin
module.exports = {"root":"IntakeFormSuccess_root__3nrKg","icon":"IntakeFormSuccess_icon__37fvd"};